<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<plant-select />
				</el-col>
				<el-col :span="4">
					<search-input :label="getMessage_('SWCC000217')" paramKey="userId" />
				</el-col>
				<el-col :span="4">
					<search-input :label="getMessage_('SWCC000218')" paramKey="userName" />
				</el-col>
				<el-col :span="5">
					<useYn-select @reload="searchList()" />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupMap/store/helpers';
import PlantSelect from './PlantSelect.vue';
import UseYnSelect from './UseYnSelect.vue';
import SearchInput from './SearchInput.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PlantSelect, UseYnSelect, SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList(currentPage = 1, pageUnit = 10) {
			this.$sf_toggleLoading(true);
			this.getUsers_({ currentPage, pageUnit })
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	created() {
		this.getPlants_()
			.then(() => {
				this.searchList();
				this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' }).catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				});
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			});
	},
	watch: {
		langCd() {
			this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' }).catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			});
		}
	}
};
</script>

<style></style>
